import script from "./Customerdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./Customerdetail.vue?vue&type=script&setup=true&lang=js"

import "./Customerdetail.vue?vue&type=style&index=0&id=001d949c&lang=css"

const __exports__ = script;

export default __exports__